import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const sendFiatBackRequest = createAsyncThunk('sendFiatBack/sendFiatBackRequest', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.sendFiatBack(payload.dataForSend, payload.method);
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
